// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_GRADES_MONTH, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/grades/month';
import type { Params, MonthMarks } from 'app/dataTypes/MonthMarks.types';
import type { Discipline } from 'app/dataTypes/Discipline.types';


export default function useMonthMarks(
  { klassId, studentId, date }: Params,
  onUpdateDIsciplines: (Array<Discipline>) => void
): [
  MonthMarks,
  boolean
] {
  const { t } = useTranslation('app');
  const [monthMarks, setMarks] = useState<MonthMarks>({});
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_GRADES_MONTH, {
      error: t('request_dnevnik_marks_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      const [d, m] = res;
      onUpdateDIsciplines(d);
      setMarks(m);
    }
    setLoading(false);
  }, [klassId, studentId, date, t, onUpdateDIsciplines]);

  useEffect(() => {
    request();
  }, [request]);

  return [monthMarks, loading];
}
